import React from 'react';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'src/services/globalMessages';

/**
 * @property body - rich text
 */
export interface IAboutUsProps {
    body: string | null;
}

const AboutUs: React.FunctionComponent<IAboutUsProps> = ({ body }) =>
    body ?
        <article className="about-us">
            <h1 className="about-us__title"><FormattedMessage {...globalMessages.aboutUs} /></h1>
            <div className="about-us__body" dangerouslySetInnerHTML={{ __html: body }} />
        </article>
        : null


export default AboutUs;